export default __webpack_public_path__ + "static/media/30y.2a5423f8.png";